import { useDynamicForm } from "@/components/dynamic-form/hook/useDynamicForm";
import { PageContainer } from "@/components/page-container";
import { TableContainer } from "@/components/table-container";
import { Table } from "@renderbus/ui";
import { useWatchPagination } from "@/components/dynamic-form/hook/useWatchPagination";
import { useDesktopColumns } from "@/pages/payment/hooks/useDesktopColumns";
import { usePaymentStore } from "../../store/payment-store";
import { RechargeRecordTabType } from "../../constants";
import { useCallback, useEffect } from "react";
import { CouponDetailType } from "@/constant";
import { useGlobalStore } from "@/store/GlobalStore";

export function DesktopRechargeRecord() {
  const { isDomestic, isSubAccount } = useGlobalStore();
  const { tableData, pageNum, fetchData, setPageNum, total, pageSize } =
    useDynamicForm({
      api: "/api/rendering/pay/recharge/queryUserCouponRecords",
      defaultPageSize: 10,
    });

  const _fetchData = useCallback(async () => {
    await fetchData({
      extraData: {
        couponType: [CouponDetailType.Desktop],
      },
    });
  }, [fetchData]);

  useWatchPagination(pageSize, pageNum, _fetchData);

  const { columns } = useDesktopColumns({
    isDomestic,
    isSubAccount,
  });
  const { activeTabKey } = usePaymentStore();

  useEffect(() => {
    if (activeTabKey === RechargeRecordTabType.Desktop) {
      _fetchData();
    }
  }, [activeTabKey, _fetchData]);
  return (
    <PageContainer>
      <TableContainer>
        <Table
          paginationCurrent={pageNum}
          columns={columns}
          dataSource={tableData}
          gap={false}
          total={total}
          defaultPageSize={pageSize}
          onPageNumChange={async (num) => {
            setPageNum(num);
          }}
        />
      </TableContainer>
    </PageContainer>
  );
}
